export default __webpack_public_path__ + "static/media/drone-shop.8f5c8453.jpg";